export default __webpack_public_path__ + "static/media/timeline1.ddba2021.svg";